import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const PrivateRoute = ({ requiredRole }) => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;

  const decoded = decodeToken(token);

  // Se token estiver inválido/malformado, força re-login.
  if (!decoded) {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    return <Navigate to="/login" replace />;
  }

  // `exp` do JWT é em segundos (padrão do JWT).
  const expMs = typeof decoded.exp === "number" ? decoded.exp * 1000 : null;
  if (expMs && Date.now() > expMs) {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    return <Navigate to="/login" replace />;
  }

  const tokenRole = decoded.role;
  if (requiredRole && tokenRole !== requiredRole) {
    return <Navigate to="/painel" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
